import { Typography } from "@mui/material";
import { TablizoCustom } from "Components/LabIZO/Tablizo";
import { SwitchButton } from "Components/SwitchButton/SwitchButton";
import { DATA_LINK } from "connectors";

export const TABLE_SCHEMA: TablizoCustom = (tbLang) => [
  {
    label: "Enabled",
    name: "disabled",
    width: 100,
    reqAuth: "FLE",
    reqLevel: 999,
    reqFunc: "Enable",
    Cell(row, field, addOns, fetchData) {
      return <SwitchButton defaultValue={!field} URL={DATA_LINK.FLEEnable} row={row} fetchData={fetchData} />;
    },
  },
  {
    label: "Alias",
    name: "alias",
  },
  {
    label: "Flow Description",
    name: "description",
  },
  {
    label: "API integration",
    name: "integrations.api.enabled",
    Cell: (row, field, addOns) => {
      return <Typography variant="body2">{field ? "Yes" : "No"}</Typography>;
    },
  },
  {
    label: "Default Answer",
    name: "answers.defaultAnsDoc._id",
  },
  {
    label: `Created Time`,
    name: `CREATED_AT`,
    filterable: false,
  },
  {
    label: `Last Updated Time`,
    name: `LASTMODIFIED`,
    filterable: false,
  },
];
